import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import COLORS from '../../colors';
import { NavEditCompleted, NavEditEmpty, NavEditProgress } from '../Icons';

const StyledNavItem = styled.li`
  padding-bottom: 8px;
`;

const StyledNavLink = styled(NavLink)`
  color: ${COLORS.NEUTRAL_500};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  text-decoration: none;
  padding: 16px;
  display: block;
  border-radius: 100px;
  transition: all 0.2s ease-in-out;

  &.disabled {
    pointer-events: none;
  }

  &.active {
    font-weight: 600;
    color: ${COLORS.NAV_ACTIVE};
    box-shadow:
      0px 1px 3px 1px rgba(0, 0, 0, 0.15),
      0px 1px 2px 0px rgba(0, 0, 0, 0.3);
    background-color: ${COLORS.CHECKED};
  }

  &.active:hover {
    background-color: ${COLORS.NAV_HOVER};
  }

  &.completed {
    background-color: ${COLORS.NEUTRAL_900};
    color: ${COLORS.NAV_COMPLETED};
  }

  &.completed:hover {
    background-color: ${COLORS.NAV_COMPLETED_HOVER};
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .left {
    display: flex;
    align-items: center;
  }

  span {
    padding-left: 12px;
  }
`;

const StyledFirstPageNavLink = styled(NavLink)`
  color: ${COLORS.NEUTRAL_500};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  text-decoration: none;
  padding: 16px;
  display: block;
  border-radius: 100px;
  transition: all 0.2s ease-in-out;

  &.disabled {
    pointer-events: none;
  }

  &.active {
    color: ${COLORS.NAV_ACTIVE};
    box-shadow:
      0px 1px 3px 1px rgba(0, 0, 0, 0.15),
      0px 1px 2px 0px rgba(0, 0, 0, 0.3);
    background-color: ${COLORS.CHECKED};
  }

  &.active:hover {
    background-color: ${COLORS.NAV_HOVER};
  }

  &.completed {
    background-color: ${COLORS.NEUTRAL_900};
    color: ${COLORS.NAV_COMPLETED};
  }

  &.completed:hover {
    background-color: ${COLORS.NAV_COMPLETED_HOVER};
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .left {
    display: flex;
    align-items: center;
  }

  span {
    padding-left: 12px;
  }
`;

interface SidebarNavigationProps {
  number: number;
  name: string;
  icon: React.ReactNode;
  location: string;
  isCompleted?: boolean;
  isDisabled?: boolean;
  onClick?: (location: string) => void;
}

const SidebarNavigation = ({
  number,
  name,
  icon,
  location,
  isCompleted = false,
  isDisabled = false,
  onClick
}: SidebarNavigationProps) => {
  const handleClick = () => {
    if (location === '#' && onClick) {
      onClick(location);
    }
  };

  return (
    <>
      {location === '#' ? (
        <StyledNavItem>
          <StyledFirstPageNavLink
            className={isDisabled ? 'disabled' : isCompleted ? 'completed' : ''}
            onClick={handleClick}
            to={location}
          >
            {({ isActive }) => (
              <div className="wrapper">
                <div className="left">
                  {icon}
                  <span>
                    {number.toString()}. {name}
                  </span>
                </div>
                {isCompleted ? (
                  <NavEditCompleted />
                ) : (
                  <>{isActive ? <NavEditProgress /> : <NavEditEmpty />}</>
                )}
              </div>
            )}
          </StyledFirstPageNavLink>
        </StyledNavItem>
      ) : (
        <StyledNavItem>
          <StyledNavLink
            className={isDisabled ? 'disabled' : isCompleted ? 'completed' : ''}
            onClick={handleClick}
            to={location}
          >
            {({ isActive }) => (
              <div className="wrapper">
                <div className="left">
                  {icon}
                  <span>
                    {number.toString()}. {name}
                  </span>
                </div>
                {isCompleted ? (
                  <NavEditCompleted />
                ) : (
                  <>{isActive ? <NavEditProgress /> : <NavEditEmpty />}</>
                )}
              </div>
            )}
          </StyledNavLink>
        </StyledNavItem>
      )}
    </>
  );
};

export default SidebarNavigation;
